import React from 'react';

import { Text } from 'src/client/components';
import { useGetRecipientLogo } from 'src/client/hooks/queries';
import { PageRecipient } from 'src/commons/types';

import * as S from './styles';

type Props = {
  recipient: PageRecipient;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => void;
};

function RecipientCard(props: Props) {
  const { recipient, isSelected, isDisabled, onClick } = props;

  const { data: recipientLogo, isLoading: isRecipientLogoLoading } =
    useGetRecipientLogo(recipient.recipientId);

  const handleClick = () => {
    if (!isDisabled) {
      onClick();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <S.Container
      $isDisabled={isDisabled}
      $isSelected={isSelected}
      aria-label={`${isSelected ? 'Deselect' : 'Select'} ${
        recipient.recipientName
      }`}
      aria-pressed={isSelected}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <S.ImageContainer>
        {isRecipientLogoLoading ? (
          <S.LoadingPlaceholder />
        ) : recipientLogo?.recipientLogoImagePath ? (
          <S.RecipientImage
            alt={`${recipient.recipientName} logo`}
            src={recipientLogo.recipientLogoImagePath}
          />
        ) : (
          <S.PlaceholderLetter>
            {recipient?.recipientName?.toUpperCase()}
          </S.PlaceholderLetter>
        )}

        {isSelected && (
          <S.SelectedIndicator>
            <S.CheckmarkIcon />
          </S.SelectedIndicator>
        )}
      </S.ImageContainer>

      <S.RecipientName>
        <Text type="body2med2">{recipient.recipientName}</Text>
      </S.RecipientName>
    </S.Container>
  );
}

export default RecipientCard;
